import { Reducer } from 'redux';
import { SettingAction } from './SettingsActions';
import { LanguageCode } from '@pdcplan/shared/generated/language/TeamPlan';
import { LoginAction, LoginEvents } from '../Login/LoginAction';

export interface SettingsReducer {
  language: LanguageCode;
  allowNotification: boolean;
  errorMessage?: string;
}

const initialState: SettingsReducer = {
  language: LanguageCode.Da,
  allowNotification: false,
};

const settingsReducer: Reducer<SettingsReducer> = (
  state: SettingsReducer = initialState,
  action: SettingAction | LoginAction
) => {
  switch (action.type) {
    case LoginEvents.LOGOUT:
      return initialState;
    case 'LANGUAGE_SELECT':
      return {
        ...state,
        language: action.language,
      };
    case 'GETALLOWNOTIFICATIONS_REQUEST':
      return {
        ...state,
      };
    case 'GETALLOWNOTIFICATIONS_SUCCESS':
      return {
        ...state,
        allowNotification: action.allowNotification,
      };
    case 'GETALLOWNOTIFICATIONS_FAILURE':
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    case 'SETALLOWNOTIFICATIONS_REQUEST':
      return {
        ...state,
      };
    case 'SETALLOWNOTIFICATIONS_SUCCESS':
      return {
        ...state,
        allowNotification: action.allowNotification,
      };
    case 'SETALLOWNOTIFICATIONS_FAILURE':
      return {
        ...state,
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
};

export default settingsReducer;
